import axios from 'axios';
import moment from 'moment';
import { replaceUrl } from '../../../../../common/utils/router';

export const changeEmailFunc = (data, setStepData, lang, setAlertData, dataToSend, setAllowedSend, setFieldsErr) => {
    const headers = {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json;charset=UTF-8',
        'Accept-Language': lang,
        'temp-token': data?.data?.temp_token
    };
    axios({
        method: 'POST',
        url: data?.meta?.links?.change_unverified_email,
        headers,
        data: JSON.stringify({
            ...dataToSend,
            email_verification_client_url: replaceUrl('/verify')
        })
    })
        .then((response) => {
            setFieldsErr({});
            setStepData((pre) => ({
                ...pre.back,
                props: {
                    ...pre?.back?.props,
                    timerDate: false,
                    counterValue: 0,
                    data: {
                        ...pre.back?.props?.data,
                        data: {
                            ...pre.data,
                            ...response.data?.data
                        },
                        userData: {
                            ...pre.back?.props?.data?.userData,
                            email: dataToSend?.email
                        }
                    }
                }
            }));
        })
        .catch((error) => {
            if (!error.response) return false;
            const { data } = error.response;

            if (data.message) {
                setAlertData({ type: 'error', cont: data.message });
            }
            if (data.errors && Object.keys(data.errors).length) {
                setFieldsErr(data.errors);
            }
            setAllowedSend(true);
        });
};
export const sendEmailFunc = (data, counter, setCounter, setTimer, setPending, lang, setAlertData) => {
    if (counter >= 3) {
        setCounter((pre) => pre++);
        setTimer(moment().add(5, 'minutes').toDate());
        return;
    }
    setPending(true);
    const headers = {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json;charset=UTF-8',
        'Accept-Language': lang,
        'temp-token': data?.data?.temp_token
    };
    axios({
        method: 'POST',
        url: data?.meta?.links?.send_email_verification,
        headers,
        data: JSON.stringify({ url: replaceUrl('/verify') })
    })
        .then(() => {
            setCounter((pre) => pre + 1);
            setAlertData({
                type: 'success',
                cont: true,
                default: 'success_send_data'
            });
        })
        .catch(() => {
            setAlertData({
                type: 'error',
                cont: true,
                default: 'error_get_data'
            });
        })
        .finally(() => {
            setPending(false);
        });
};
